<h1 class="changelog-title" mat-dialog-title>{{ "app.footer.changelog" | translate }}</h1>
<div mat-dialog-content>
	<div [innerHTML]="markdownHtml"></div>
</div>
<div class="actions" mat-dialog-actions>
	<button (click)="close()" cdkFocusInitial class="button-close" mat-button mat-dialog-close>{{ "i18n.common.close" | translate }}</button>
</div>
